import 'css-chunksrc/client/scenes/resourceEdition/allocationManagement/resource/user/styles.scss';export default {
  "resource": "_resource_1ehqb_1",
  "user": "_user_1ehqb_8",
  "avatar": "_avatar_1ehqb_21",
  "name": "_name_1ehqb_33",
  "title": "_title_1ehqb_42"
};